import { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import Datetime from "react-datetime";
import { validatePhoneNumber } from "../../../common/helper";
import { PreCandidateService } from "../../../services/PreCandidate";
import { useInterviewContext } from "../InterviewContext";
import NationalityPersonalInformation from "./NationalityPersonalInformation";
import { useTranslation } from "react-i18next";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";
import { isValidEmail } from "../../../common/helper";
import ModalAlertToCloneLastInterview from "./ModalAlertToCloneLastInterview";
import { toast } from "react-toastify";
import moment from "moment";
import CurrentLocation from "./CurrentLocation";
import Select from "../../../components/Select";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import pt from "react-phone-number-input/locale/pt";
import es from "react-phone-number-input/locale/es";
import fr from "react-phone-number-input/locale/fr";
import en from "react-phone-number-input/locale/en";
import { useGeneralContext } from "../../General/Context";

const PersonalInformation = () => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const {
    addressZone,
    maritalStatus,
    setErrors,
    interview,
    setInterview,
    errors,
    GetInterviewById,
    setIsTabsDisabled,
    validateInterviewMainInputs,
    editMode,
    numberOfDependents,
    docOnlineLanguages
  } = useInterviewContext();
  const { personalInformation } = interview;
  const [
    showModalAlertToCloneLastInterview,
    setShowModalAlertToCloneLastInterview
  ] = useState(false);
  const [preCandidateIdSelected, setPreCandidateIdSelected] = useState(0);
  const { userInformation } = useGeneralContext();

  useEffect(() => {
    if (personalInformation.fullName && personalInformation.emailAddress) {
      if (validateInterviewMainInputs() && phoneNumberIsValid()) {
        setIsTabsDisabled(false);
      } else {
        setIsTabsDisabled(true);
      }
    } else {
      setIsTabsDisabled(true);
    }

    if (!interview.docOnlineLanguageId && docOnlineLanguages.length > 0) {
      let docOnlineLanguage = docOnlineLanguages.find(
        (item) => item.initials === userInformation.langCode
      ).id;
      setInterview({
        ...interview,
        docOnlineLanguageId: docOnlineLanguage
      });
    }
  }, [
    personalInformation.fullName,
    personalInformation.emailAddress,
    setIsTabsDisabled,
    docOnlineLanguages
  ]);

  const phoneNumberIsValid = () => {
    if (personalInformation.mobilePhoneNumber) {
      const errorPhoneNumber = validatePhoneNumber(
        personalInformation.mobilePhoneNumber,
        25
      );
      if (errorPhoneNumber.format || errorPhoneNumber.maxLength) {
        return false;
      }
    }
    return true;
  };

  const onChangeEmailAddress = ({ target }) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      personalInformation: {
        ...prevInterview.personalInformation,
        emailAddress: target.value
      }
    }));
  };

  const confirmCloneLastInterview = () => {
    setShowModalAlertToCloneLastInterview(false);
    if (preCandidateIdSelected !== 0) {
      PreCandidateService.CreateInterview(preCandidateIdSelected).then(
        (interviewId) => {
          GetInterviewById(interviewId);
        }
      );
    } else {
      toast.error(
        t(
          "An error has been detected, please try to refresh the page if the error persists contact the support team."
        )
      );
    }
  };

  const onChangeBirthDate = (date) => {
    if (date._d) {
      setErrors({ ...errors, birthDate: null });
      if (!validateDateOfBirth(date)) {
        setErrors({ ...errors, birthDate: t("The birth date is invalid.") });
        return;
      }
    }

    setInterview((prevInterview) => ({
      ...prevInterview,
      personalInformation: {
        ...prevInterview.personalInformation,
        birthDate: date._d
      }
    }));
  };

  const validateDateOfBirth = (currentDate) => {
    let date = new Date();
    const maxAge = 72;
    const minAge = 18;
    const years = currentDate._d.getFullYear();
    const currentYear = date.getFullYear();

    if (currentDate >= date) {
      return false;
    } else if (years + maxAge < currentYear) {
      return false;
    } else if (years + minAge > currentYear) {
      return false;
    }
    return true;
  };

  const getDateValueValid = (date) => {
    if (date) {
      return moment(new Date(personalInformation.birthDate)).format(
        "DD-MM-YYYY"
      );
    }
  };

  function onChangePhoneNumber(target) {
    const errorPhoneNumber = validatePhoneNumber(target, 25);
    if (errorPhoneNumber.format) {
      setErrors({
        ...errors,
        mobilePhoneNumber: t("The mobile number format is invalid.")
      });
      setIsTabsDisabled(true);
    } else if (errorPhoneNumber.maxLength) {
      setErrors({
        ...errors,
        mobilePhoneNumber:
          t("The maximum number of characters is") +
          " " +
          errorPhoneNumber.maxNum
      });
      setIsTabsDisabled(true);
    } else {
      setErrors({ ...errors, mobilePhoneNumber: null });
      if (validateInterviewMainInputs()) {
        setIsTabsDisabled(false);
      }
    }

    setInterview((prevInterview) => ({
      ...prevInterview,
      personalInformation: {
        ...prevInterview.personalInformation,
        mobilePhoneNumber: target
      }
    }));
  }

  const validateMail = ({ target }) => {
    if (!isValidEmail(target.value) && target.value !== "") {
      setErrors({
        ...errors,
        emailAddress: t("The Email Address is required.")
      });
    } else {
      setErrors({ ...errors, emailAddress: null });
    }
  };

  const addNewNationality = () => {
    // prevents to have multiple empty nationalities
    if (personalInformation.nationalityId.at(-1) !== 0) {
      setInterview((prevInterview) => ({
        ...prevInterview,
        personalInformation: {
          ...prevInterview.personalInformation,
          nationalityId: [...prevInterview.personalInformation.nationalityId, 0]
        }
      }));
    }
  };

  const onChangePersonalInformation = (event) =>
    setInterview((prevInterview) => ({
      ...prevInterview,
      personalInformation: {
        ...prevInterview.personalInformation,
        [`${event.target.name}`]: event.target.value
      }
    }));

  const onChangeDropDown = (event) =>
    setInterview((prevInterview) => ({
      ...prevInterview,
      personalInformation: {
        ...prevInterview.personalInformation,
        [`${event.target.name}`]: Number(event.target.value)
      }
    }));

  function setCurrentLocation(currentLocation) {
    setInterview((prevInterview) => ({
      ...prevInterview,
      personalInformation: {
        ...prevInterview.personalInformation,
        currentLocation: currentLocation
      }
    }));
  }

  function positionAddNationality() {
    if (i18n.language === "PT") {
      return "button-nationality-pt";
    } else if (i18n.language === "EN") {
      return "button-nationality-en";
    } else if (i18n.language === "FR") {
      return "button-nationality-fr";
    } else {
      return "";
    }
  }

  return (
    <>
      <form className="form-group">
        <Row>
          <h1>{t("Personal Details")}</h1>
          <Row>
            <div className="col-md-6">
              <div className="form-group">
                <div className="label-wrapper">
                  <label htmlFor="personalDetailLabelFullName">
                    {t("Full Name*")}
                  </label>
                  {errors.fullName && (
                    <div className="error-msg">{errors.fullName}</div>
                  )}
                </div>
                <input
                  id="fullName"
                  name="fullName"
                  type="text"
                  onChange={onChangePersonalInformation}
                  value={interview.personalInformation.fullName}
                  placeholder={t("Name")}
                  maxLength={100}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <div className="label-wrapper">
                  <label htmlFor="personalDetailLabelDateOfBirth">
                    {t("Date of birth*")}
                  </label>
                  {errors.birthDate && (
                    <div className="error-msg">{errors.birthDate}</div>
                  )}
                </div>
                <Datetime
                  inputProps={{
                    id: "birthDate",
                    placeholder: t("dd-mm-yyyy")
                  }}
                  name="birthDate"
                  dateFormat="DD-MM-YYYY"
                  timeFormat={false}
                  onChange={onChangeBirthDate}
                  value={getDateValueValid(
                    interview.personalInformation.birthDate
                  )}
                  utc={true}
                  isValidDate={validateDateOfBirth}
                  closeOnSelect={true}
                  locale={
                    i18n.language === "PT"
                      ? "PT"
                      : i18n.language === "FR"
                      ? "FR"
                      : "EN"
                  }
                />
              </div>
            </div>
          </Row>{" "}
          <Row style={{ alignItems: "center" }}>
            <div className="col-md-4">
              <div className="form-group">
                <div className="label-wrapper">
                  <label htmlFor="personalDetailLabelMaritalStatus">
                    {t("Marital Status")}
                  </label>
                </div>
                <select
                  id="maritalStatusId"
                  name="maritalStatusId"
                  onChange={onChangeDropDown}
                  value={interview.personalInformation.maritalStatusId || null}
                  required
                  title={t("Selecione um item da lista.")}
                >
                  <option selected>{t("Marital status...")}</option>
                  {maritalStatus &&
                    maritalStatus.map((item) => (
                      <option key={item.id} value={item.id}>
                        {t(item.description)}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <div className="label-wrapper">
                  <label htmlFor="personalDetailLabelNumberOfDependants">
                    {t("Nº of dependants")}
                  </label>
                </div>
                <Select
                  id="numberOfDependents"
                  name="numberOfDependents"
                  onChange={onChangeDropDown}
                  value={
                    interview.personalInformation.numberOfDependents || null
                  }
                  required
                  title={t("Selecione um item da lista.")}
                >
                  <option value={null} selected>
                    {t("Select a number...")}
                  </option>
                  {numberOfDependents?.map((item, index) => (
                    <option key={index} value={item.id}>
                      {t(item.description)}
                    </option>
                  ))}
                </Select>
              </div>
            </div>
          </Row>
          <Row>
            <div className="col-md-3">
              <div className="form-group">
                <div className="label-wrapper">
                  <label htmlFor="personalDetailLabelZone">{t("Zone")}</label>
                </div>
                <Select
                  required
                  id="zoneId"
                  name="zoneId"
                  onChange={onChangeDropDown}
                  value={interview.personalInformation.zoneId || 0}
                  title={t("Selecione um item da lista.")}
                >
                  <option key={0} value={0} selected>
                    {t("Zone...")}
                  </option>
                  {addressZone.map((item) => (
                    <option key={item.id} value={item.id}>
                      {t(item.description)}
                    </option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="col-md-5">
              <CurrentLocation
                currentLocation={interview.personalInformation.currentLocation}
                setCurrentLocation={setCurrentLocation}
              ></CurrentLocation>
            </div>
          </Row>
          <div>
            {interview.personalInformation.nationalityId.length > 0 ? (
              interview.personalInformation.nationalityId.map(
                (nationality, index) => (
                  <NationalityPersonalInformation
                    index={index}
                    nationalityId={nationality}
                  />
                )
              )
            ) : (
              <NationalityPersonalInformation index={0} />
            )}
          </div>
          <div className="col-md-4">
            {interview.personalInformation.nationalityId.length < 3 && (
              <button
                onClick={addNewNationality}
                type="button"
                className={`app-button btn-prime btn-lg ${positionAddNationality(
                  i18n.language
                )}`}
              >
                {t("+ Add nationality")}
              </button>
            )}
          </div>
        </Row>
        <Row>
          <h1>{t("Contacts")}</h1>
          <Row>
            <div className="col-md-4">
              <div className="form-group">
                <div className="label-wrapper">
                  <label>{t("Email address*")}</label>
                  {errors.emailAddress && (
                    <div className="error-msg">{errors.emailAddress}</div>
                  )}
                </div>
                {editMode ? (
                  <input
                    className="input-field"
                    value={interview.personalInformation.emailAddress}
                    maxLength={100}
                    disabled
                  />
                ) : (
                  <input
                    className="input-field"
                    value={interview.personalInformation.emailAddress || ""}
                    onChange={onChangeEmailAddress}
                    onBlur={validateMail}
                    placeholder={t("email@example.com")}
                    maxLength={100}
                  />
                )}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <div className="label-wrapper">
                  <label htmlFor="personalDetailLabelPhoneNumber">
                    {t("Mobile number")}
                  </label>
                  {errors.mobilePhoneNumber && (
                    <div className="error-msg">{errors.mobilePhoneNumber}</div>
                  )}
                </div>
                <PhoneInput
                  className="input-field"
                  id="mobilePhoneNumber"
                  name="mobilePhoneNumber"
                  type="tel"
                  international
                  defaultCountry={
                    userInformation.langCode === "ES"
                      ? "ES"
                      : userInformation.langCode === "EN" &&
                        userInformation.companyAbbreviation === "AGAP2NL"
                      ? "NL"
                      : userInformation.langCode === "EN" &&
                        userInformation.companyAbbreviation === "GMS"
                      ? "DE"
                      : "PT"
                  }
                  labels={
                    i18n.language === "PT"
                      ? pt
                      : i18n.language === "FR"
                      ? fr
                      : i18n.language === "EN"
                      ? en
                      : es
                  }
                  countryCallingCodeEditable={false}
                  value={interview.personalInformation.mobilePhoneNumber}
                  onChange={onChangePhoneNumber}
                />
              </div>
            </div>
          </Row>
        </Row>
        <Row className="section-divider">
          <h1>{t("Links")}</h1>
          <Row>
            <div className="col-md-4">
              <div className="form-group">
                <div className="label-wrapper">
                  <label htmlFor="personalDetailLabelLinkedin">
                    LinkedIn (URL)
                  </label>
                </div>
                <input
                  className="input-field"
                  type="text"
                  placeholder="https://www.linkedin.com/in"
                  id="linkedIn"
                  name="linkedIn"
                  onChange={onChangePersonalInformation}
                  value={interview.personalInformation.linkedIn}
                  maxLength={250}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <div className="label-wrapper">
                  <label htmlFor="personalDetailLabelGitHub">
                    GitHub (URL)
                  </label>
                </div>
                <input
                  className="input-field"
                  type="text"
                  placeholder="https://github.com"
                  id="gitHub"
                  name="gitHub"
                  onChange={onChangePersonalInformation}
                  value={interview.personalInformation.gitHub}
                  maxLength={250}
                />
              </div>
            </div>
          </Row>
        </Row>
      </form>
      <ModalAlertToCloneLastInterview
        showModal={showModalAlertToCloneLastInterview}
        submitButtonAction={() => confirmCloneLastInterview()}
        setShowModal={setShowModalAlertToCloneLastInterview}
      />
    </>
  );
};

export default PersonalInformation;
